export default __webpack_public_path__ + "assets/audios/d1978a9b378c152202ad73bf7774f59e.mp3";